import { useState, useRef, useCallback, MutableRefObject } from "react";

function useStateRef<T>(defaultValue: T): [T, (val: T | ((prev: T) => T)) => void, MutableRefObject<T>] {
	const [state, setState] = useState<T>(defaultValue);
	const ref = useRef(state);

	const dispatch = useCallback((val: T | ((prev: T) => T)) => {
		if (typeof val === "function") {
			const fn = val as (prev: T) => T;
			ref.current = fn(ref.current);
		} else {
			ref.current = val;
		}
		setState(ref.current);
	}, []);

	return [state, dispatch, ref];
}

export default useStateRef;
